import React from 'react';

import { FormContext } from '../contexts';
import { FormMode } from '../enums';

export const useFormContext = (): {
  setValueByName: (inputName: string | undefined | null, value: unknown) => void;
} => {
  const { formDispatch, formMode } = React.useContext(FormContext);

  const setValueByName = (inputName: string | undefined | null, value: unknown): void => {
    if (!formDispatch || formMode === FormMode.ReadOnly || inputName == null || inputName === '') {
      return;
    }
    formDispatch({
      type: 'FormChangeByInputName',
      inputName: inputName,
      payload: value
    });
  };

  return { setValueByName };
};
